<template>
  <div>
    <span class="f-14 font-weight-regular label">
      Test {{ computedTitle }} Mail Server
    </span>
    <div class="wrapper-1 pa-4 d-flex align-center">
      <!--EMAIL TO TEST -->
      <v-text-field
        v-model="testEmail"
        :rules="emailRules"
        :disabled="!isSettingsEnabled"
        class="mr-2 mw-250"
        dense
        label="Send To"
        validate-on-blur
      >
      </v-text-field>

      <!--MESSAGE TO WRITE IN EMAIL-->
      <v-text-field
        v-model="testMessage"
        :disabled="!isSettingsEnabled"
        class="mr-2 mw-250"
        dense
        label="Message"
      >
      </v-text-field>

      <!--RUN TEST-->
      <v-btn
        @click="runTest"
        :loading="isLoadingTest"
        :disabled="isTestBtnDisabled || !isSettingsEnabled"
        color="info"
        small
        >Test</v-btn
      >
    </div>
  </div>
</template>

<script>
import { api } from '@/config'
import { validateEmail } from '@/utils'
import { mapMutations } from 'vuex'

export default {
  name: 'TestEmail',
  data() {
    return {
      testEmail: '',
      testMessage: '',
      isLoadingTest: false,
    }
  },

  props: {
    organization: Object,
    isSettingsEnabled: Boolean,
    backupType: Number,
    setIsCheckSmtpChange: Function,
    setIsCheckBackupSmtpChange: Function,
    setIsCheckSecondBackupSmtpChange: Function,
  },

  computed: {
    isTestBtnDisabled() {
      return !this.testMessage || !validateEmail(this.testEmail)
    },
    emailRules() {
      return [
        v => !!v || 'Email is required',
        v => validateEmail(v) || 'Email must be valid',
      ]
    },
    computedTitle() {
      switch (this.backupType) {
        case 0:
          return ''
        case 1:
          return 'Backup '
        case 2:
          return 'Secondary Backup '
      }
    }
  },

  methods: {
    ...mapMutations(['SET_NOTIFICATION']),
    async runTest() {
      let emailDefinitions;

      switch (this.backupType) {
        case 0:
          emailDefinitions = this.organization.emailDefinitions
          break
        case 1:
          emailDefinitions = this.organization.backupEmailDefinitions
          break
        case 2:
          emailDefinitions = this.organization.secondBackupEmailDefinitions
          break
      }
      try {
        this.isLoadingTest = true
        const body = {
          message: this.testMessage,
          email: this.testEmail,
        }

        if (emailDefinitions.emailProtocol === 'SMTP') {
          const { server, senderEmail, port, password, encrypt } =
            emailDefinitions.smtpDefinitions

          body.smtpDefinitions = {
            server,
            port,
            password,
            encrypt,
            senderEmail,
          }

          const res = await api.post('organizations/testsmtp', body)

          if (res.status !== 200)
            throw new Error(decodeURIComponent(res.headers['reason-phrase']))
        }

        else {
          const { clientId, tenantId, clientSecret, senderEmail } =
            emailDefinitions.msGraphDefinitions

          body.msGraphDefinitions = {
            clientId,
            tenantId,
            clientSecret,
            senderEmail,
          }

          const res = await api.post('organizations/testmsgraph', body)

          if (res.status !== 200)
            throw new Error(decodeURIComponent(res.headers['reason-phrase']))
        }

        //if everything is okay
        switch (this.backupType) {
        case 0:
          this.setIsCheckSmtpChange(true)
          break
        case 1:
          this.setIsCheckBackupSmtpChange(true)
          break
        case 2:
          this.setIsCheckSecondBackupSmtpChange(true)
          break
      }

        this.SET_NOTIFICATION({
          type: 'success',
          text: 'Success, check your email',
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoadingTest = false
      }
      
    },
  },
}
</script>
